// Styles personnalisés pour React Select
export const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? "#d97706" : "#d1d5db",
    boxShadow: state.isFocused ? "0 0 0 2px rgba(217, 119, 6, 0.2)" : null,
    "&:hover": {
      borderColor: "#d97706",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#d97706"
      : state.isFocused
      ? "#fef3c7"
      : "white",
    color: state.isSelected ? "white" : "#374151",
    "&:hover": {
      backgroundColor: state.isSelected ? "#d97706" : "#fef3c7",
      color: state.isSelected ? "white" : "#374151",
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#fef3c7",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#92400e",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#92400e",
    "&:hover": {
      backgroundColor: "#d97706",
      color: "white",
    },
  }),
};
